import { ConfirmModal } from '@sparklayer-io/spark-dash-ui/components/confirm-modal';
import { t } from 'i18next';
import { Trans } from 'react-i18next';
import { useHandlers } from '../../../../context/page-context';
import { PriceListError } from '../../errors';
import { useDeletePriceList } from '../../hooks/use-delete-price-list';
import type { PriceList } from '../../types';

export function DeletePriceListModal({
  priceList,
  isOpen,
  closeModal,
  onDeleted,
}: {
  priceList: PriceList | null;
  isOpen: boolean;
  closeModal: () => void;
  onDeleted?: () => void;
}) {
  const { notificationHandler } = useHandlers();
  const deletePriceList = useDeletePriceList();

  if (!priceList) {
    return null;
  }

  // Using arrow function here to avoid hoisting
  const handleDelete = () => {
    deletePriceList.mutate(priceList.slug, {
      onError: (error) => {
        if (error instanceof PriceListError) {
          notificationHandler.error(
            t(`price_lists.notifications.errors.${error.id}`, { name: priceList.name }),
          );
          return;
        }

        notificationHandler.error(t('price_lists.notifications.errors.delete_failed'));
      },
      onSuccess: () => {
        notificationHandler.success(
          t('price_lists.notifications.success.delete_succeeded', { name: priceList.name }),
        );
        onDeleted?.();
      },
    });
  };

  return (
    <ConfirmModal
      isOpen={isOpen}
      onClose={closeModal}
      onConfirm={() => {
        handleDelete();
        closeModal();
      }}
      loading={deletePriceList.isPending}
      title={t('price_lists.modals.confirm_delete.title', { name: priceList.name })}
      confirmText={t('pages:price_lists.modals.confirm_delete.delete')}
      message={
        <Trans i18nKey="price_lists.modals.confirm_delete.body" values={{ name: priceList.name }} />
      }
    />
  );
}
